import { api } from './api';

export type ApprovalKind = 'forecast' | 'dashboard' | 'variance' | 'board_pack';
export type ApprovalStatus = 'pending' | 'approved' | 'rejected' | 'cancelled';

export interface ApprovalHistoryEntry {
  step: number;
  user_id: string;
  action: 'approved' | 'rejected';
  note: string | null;
  at: string;
}

export interface Approval {
  id: string;
  workspaceId: string;
  targetKind: ApprovalKind;
  targetId: string;
  requiredSigners: string[];
  currentStep: number;
  status: ApprovalStatus;
  history: ApprovalHistoryEntry[];
  initiatedBy: string | null;
  amount: number | null;
  createdAt: string;
  updatedAt: string;
}

/** A 稟議 routing tier: amounts up to `upTo` (null = top tier) add `approvers`. */
export interface RingiTier {
  upTo: number | null;
  approvers: string[];
}

export interface CreateApprovalBody {
  targetKind: ApprovalKind;
  targetId: string;
  /** Provide signers explicitly, OR an amount + tiers to route them. */
  requiredSigners?: string[];
  amount?: number;
  tiers?: RingiTier[];
}

export const approvalsApi = {
  async list(workspaceId: string): Promise<Approval[]> {
    const r = await api.get<Approval[]>(`/api/workspaces/${workspaceId}/approvals`);
    return r.data;
  },
  async create(workspaceId: string, body: CreateApprovalBody): Promise<Approval> {
    const r = await api.post<Approval>(`/api/workspaces/${workspaceId}/approvals`, body);
    return r.data;
  },
  async act(id: string, body: { action: 'approve' | 'reject'; note?: string }): Promise<Approval> {
    const r = await api.post<Approval>(`/api/approvals/${id}/act`, body);
    return r.data;
  },
};
